import _get from "lodash/get";

import RatingStar from "@components/Icons/RatingStar";

const SellerReviewsChart = ({ reviewsSummary }) => {
  const reviewsCount = _get(reviewsSummary, "items[0].reviews.value", 0);
  let reviewSummaryElements = [];
  for (let index = 5; index > 0; index--) {
    let styles = { width: "", backgroundColor: "" };
    let distribution = 0;
    switch (index) {
      case 5:
        styles.width = `${parseFloat(
          (_get(reviewsSummary, "items[0].ratingDistribution[5]", 0) * 100) /
            reviewsCount
        ).toFixed(2)}%`;
        styles.backgroundColor = "#DCE02B";
        distribution = _get(
          reviewsSummary,
          "items[0].ratingDistribution[5]",
          0
        );
        break;
      case 4:
        styles.width = `${parseFloat(
          (_get(reviewsSummary, "items[0].ratingDistribution[4]", 0) * 100) /
            reviewsCount
        ).toFixed(2)}%`;
        styles.backgroundColor = "#A3D720";
        distribution = _get(
          reviewsSummary,
          "items[0].ratingDistribution[4]",
          0
        );
        break;
      case 3:
        styles.width = `${parseFloat(
          (_get(reviewsSummary, "items[0].ratingDistribution[3]", 0) * 100) /
            reviewsCount
        ).toFixed(2)}%`;
        styles.backgroundColor = "#DCE02B";
        distribution = _get(
          reviewsSummary,
          "items[0].ratingDistribution[3]",
          0
        );
        break;
      case 2:
        styles.width = `${parseFloat(
          (_get(reviewsSummary, "items[0].ratingDistribution[2]", 0) * 100) /
            reviewsCount
        ).toFixed(2)}%`;
        styles.backgroundColor = "#FD861A";
        distribution = _get(
          reviewsSummary,
          "items[0].ratingDistribution[2]",
          0
        );
        break;
      case 1:
        styles.width = `${parseFloat(
          (_get(reviewsSummary, "items[0].ratingDistribution[1]", 0) * 100) /
            reviewsCount
        ).toFixed(2)}%`;
        styles.backgroundColor = "#D71541";
        distribution = _get(
          reviewsSummary,
          "items[0].ratingDistribution[1]",
          0
        );
        break;
      default:
        styles.width = ``;
        styles.backgroundColor = "";
    }
    reviewSummaryElements.push(
      <div key={index.toString() + "1"} className="flex items-center mb-2">
        <div className="w-2 text-sm font-bold leading-15.6">{index}</div>
        <div>
          <RatingStar className="w-13px h-13px ml-3px text-yellow" />
        </div>
        <div className="h-3 mx-3 relative overflow-hidden rounded-full grow bg-newGray">
          <div
            className="absolute rounded-full top-0 left-0 bottom-0"
            style={styles}
          ></div>
        </div>
        <div className="w-6 text-sm text-red-brand leading-15.6">
          {distribution}
        </div>
      </div>
    );
  }

  return (
    <div className="md:ml-52px w-full md:max-w-[525px]">
      {reviewSummaryElements}
    </div>
  );
};

export default SellerReviewsChart;
